// Capacidad del tanque (L) de la unidad, opcional. Con ella la bitácora
// convierte el % de combustible en litros y calcula km/L
// (ESPECIFICACION.txt §1.5 paso 8); sin ella muestra "—".
//
// Contrato del backend (POST/PUT /vehicle, campo fuelCapacity): litros de 0 a
// 2000 (decisión de Daniel, 19-oct); 0 o vacío = "sin capacidad" (error FuelCapacityRangeInvalid fuera de
// rango). Vacío se manda como 0 para que, al editar, borrar el campo la quite.
export const MAX_FUEL_CAPACITY_L = 2000;

export const toFuelCapacity = (v: unknown): number => {
  if (v == null || String(v).trim() === "") return 0;
  return Number(String(v).trim().replace(",", "."));
};

export const isValidFuelCapacity = (v: number | undefined) => v === undefined || (Number.isFinite(v) && v >= 0 && v <= MAX_FUEL_CAPACITY_L);

// Al abrir el formulario: 0 se muestra vacío, no como "0".
export const fuelCapacityField = (v: number | null | undefined) => (v && v > 0 ? v : undefined);
